var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', [_c('Header', {
    attrs: {
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section'),
      "meta": _vm.meta
    }
  }), _vm.page === 'scan' ? _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.scanTitle))]), _c('div', {
    staticClass: "card__info"
  }, [_c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : _vm._e(), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.redeem_code,
      expression: "redeem_code"
    }],
    staticClass: "search__input m-auto w-100",
    domProps: {
      "value": _vm.redeem_code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.redeem_code = $event.target.value;
      }
    }
  }), _c('SharedButton', {
    staticClass: "s-btn-bg-primary mt-3",
    on: {
      "click": _vm.manualInput
    }
  }, [_vm._v(" 送出 ")])], 1)], 1)])])]) : _vm._e(), _vm.page === 'redeem' ? _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "redeem"
  }, [_c('span', {
    staticClass: "redeem__code"
  }, [_vm._v(_vm._s(_vm.redeem_code))])]), _c('div', {
    staticClass: "card__divider"
  }), _c('div', {
    staticClass: "card__info"
  }, [_vm.event ? [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.confirmTitle))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmMessage)
    }
  })] : _vm._e()], 2)]), _c('div', {
    staticClass: "btn"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs s-mb-3",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        return _vm.redeem();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmButtonText) + " ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        return _vm.backToScan();
      }
    }
  }, [_vm._v(" 輸入 ")])])]) : _vm._e(), _vm.page === 'status' ? _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(" " + _vm._s(_vm.statusTitle) + " ")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.statusMessage)
    }
  })])]), _c('div', {
    staticClass: "btn"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.cancelButtonText,
      "button-url": _vm.cancelButtonUrl,
      "type": _vm.cancelButtonAction
    }
  }), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs s-mt-3",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        return _vm.backToScan();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.rescanButtonText) + " ")])], 1)]) : _vm._e()], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }